import React from 'react';
export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <p>© {new Date().getFullYear()} Adrian Galvan. Built with React.</p>
        <div className="socials">
          <a href="https://github.com/Khuuun">GitHub</a>
          <a href="https://www.linkedin.com/in/adrian-galvan-4a1794305/">
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}
